var _path, _path2, _g, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _g4, _path8, _path9, _g5, _path10, _path11, _g6, _path12, _path13, _g7, _path14, _path15, _g8, _path16, _path17, _g9, _path18, _path19, _g10, _path20, _path21, _g11, _path22, _path23, _g12, _path24, _g13, _path25, _g14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInterswitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 79,
    viewBox: "0 0 286 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.2809 41.244L95.2445 35.7576C95.2445 35.7576 87.8238 33.3475 81.7843 37.8171V59.7646H88.1978V41.9332C90.7536 39.8737 94.2809 41.244 94.2809 41.244Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13_2348",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 81,
    y: 35,
    width: 15,
    height: 25
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7842 37.8169C84.6901 35.6669 87.9159 35.1087 90.4809 35.1091C93.2468 35.1091 95.2448 35.7578 95.2448 35.7578L94.2808 41.2441C94.2808 41.2441 90.7534 39.8739 88.1977 41.933V59.7644H81.7842V37.8169Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13_2348)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-308.628 127.788L594.561 127.788L594.561 -1151.73H-308.628L-308.628 127.788Z",
    fill: "#58595B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13_2348",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 81,
    y: 35,
    width: 15,
    height: 25
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7842 37.8169C84.6901 35.6669 87.9154 35.1091 90.4809 35.1091C93.2468 35.1091 95.2448 35.7578 95.2448 35.7578L94.2808 41.2441C94.2808 41.2441 90.7534 39.8739 88.1977 41.933V59.7644H81.7842V37.8169Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13_2348)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0319 70.5171H105.997V24.3569H71.0319V70.5171Z",
    fill: "#58595B"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9886 29.5007L45.3992 28.293V35.431H51.7428V41.1393H45.3992V49.6521C45.3992 51.1023 45.6337 52.2535 46.1132 53.1049C46.5873 53.9692 47.5379 54.3976 48.9655 54.3976C49.6636 54.3976 50.3646 54.3306 51.1041 54.1886C51.8228 54.0442 52.4928 53.8587 53.0958 53.6158L54.0029 58.9627C53.2269 59.2956 52.3693 59.5846 51.4237 59.8295C50.4752 60.072 49.3105 60.1985 47.9345 60.1985C46.1853 60.1985 44.7396 59.9435 43.5901 59.4376C42.4464 58.9317 41.5268 58.2219 40.8413 57.3161C40.1558 56.4182 39.6737 55.3164 39.4032 54.0262C39.1277 52.7384 38.9886 51.3163 38.9886 49.7476V29.5007Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_13_2348",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 28,
    width: 17,
    height: 33
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9888 29.5005L45.3994 28.2927V35.4307H51.7429V41.139H45.3994V49.6519C45.3994 51.1025 45.6339 52.2533 46.1129 53.1046C46.587 53.9694 47.5376 54.3974 48.9652 54.3974C49.6633 54.3974 50.3639 54.3304 51.1039 54.1884C51.8225 54.0439 52.4929 53.8584 53.096 53.616L54.0026 58.9625C53.2271 59.2958 52.369 59.5847 51.4234 59.8297C50.4749 60.0722 49.3103 60.1982 47.9342 60.1982C46.1845 60.1982 44.7394 59.9432 43.5903 59.4373C42.4461 58.9315 41.5261 58.2216 40.841 57.3162C40.1555 56.418 39.6739 55.3162 39.4033 54.0259C39.1274 52.7382 38.9888 51.3165 38.9888 49.7473V29.5005Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_13_2348)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-308.628 127.788L594.561 127.788L594.561 -1151.73H-308.628L-308.628 127.788Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.236 70.9507H64.7545V17.5402H28.236L28.236 70.9507Z",
    fill: "#58595B"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.74 54.8497C105.912 54.8497 106.742 54.7203 107.234 54.4778C107.724 54.2329 107.961 53.7529 107.961 53.0511C107.961 52.4962 107.652 52.0137 107.017 51.6034C106.384 51.1854 105.43 50.721 104.137 50.1917C103.135 49.7917 102.223 49.3793 101.401 48.9534C100.589 48.5199 99.8933 48.0141 99.3188 47.4127C98.7463 46.8143 98.3032 46.0965 97.9837 45.2606C97.6642 44.4398 97.5126 43.4465 97.5126 42.2748C97.5126 40.0063 98.3032 38.2076 99.8778 36.8889C101.455 35.5756 103.614 34.9048 106.371 34.9048C107.75 34.9048 109.069 35.0362 110.331 35.3022C111.591 35.5602 112.599 35.8545 113.338 36.151L112.222 41.4925C111.475 41.2165 110.664 40.9741 109.79 40.7626C108.917 40.5461 107.933 40.4322 106.845 40.4322C104.838 40.4322 103.833 41.036 103.833 42.2308C103.833 42.5068 103.877 42.7522 103.964 42.9662C104.052 43.1831 104.222 43.3895 104.475 43.588C104.74 43.7845 105.085 44.006 105.533 44.2334C105.979 44.4733 106.546 44.7208 107.234 45.0022C108.633 45.5596 109.795 46.1015 110.713 46.6489C111.632 47.1958 112.354 47.7716 112.887 48.411C113.418 49.0358 113.795 49.7277 114.006 50.4961C114.217 51.2629 114.328 52.1478 114.328 53.157C114.328 55.549 113.488 57.3577 111.815 58.581C110.135 59.7992 107.76 60.4131 104.691 60.4131C102.686 60.4131 101.016 60.2351 99.6844 59.8612C98.3472 59.4973 97.4247 59.1827 96.9095 58.9399L97.9837 53.371C99.0687 53.8304 100.197 54.1863 101.336 54.4552C102.491 54.7182 103.614 54.8497 104.74 54.8497Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_13_2348",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 34,
    width: 19,
    height: 27
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8776 36.8893C101.455 35.5756 103.614 34.9048 106.371 34.9048C107.75 34.9048 109.069 35.0362 110.331 35.3022C111.591 35.5602 112.599 35.8541 113.338 36.151L112.223 41.4925C111.475 41.2165 110.664 40.9741 109.79 40.7626C108.917 40.5456 107.932 40.4326 106.845 40.4326C104.838 40.4326 103.833 41.0356 103.833 42.2308C103.833 42.5068 103.876 42.7522 103.964 42.9662C104.052 43.1831 104.222 43.3895 104.475 43.5881C104.74 43.7845 105.085 44.006 105.534 44.2334C105.979 44.4729 106.546 44.7212 107.234 45.0022C108.633 45.5596 109.795 46.1015 110.713 46.6489C111.633 47.1958 112.354 47.7712 112.888 48.411C113.418 49.0358 113.794 49.7273 114.006 50.4961C114.217 51.2629 114.327 52.1478 114.327 53.157C114.327 55.549 113.487 57.3581 111.816 58.581C110.135 59.7992 107.76 60.4131 104.691 60.4131C102.686 60.4131 101.017 60.2351 99.6845 59.8612C98.3469 59.4973 97.4248 59.1827 96.9093 58.9399L97.9839 53.371C99.0689 53.8308 100.197 54.1863 101.336 54.4552C102.49 54.7178 103.614 54.8497 104.74 54.8497C105.912 54.8497 106.742 54.7207 107.234 54.4778C107.724 54.2329 107.961 53.7529 107.961 53.0511C107.961 52.4962 107.652 52.0137 107.018 51.6034C106.384 51.1854 105.43 50.721 104.137 50.1917C103.134 49.7917 102.223 49.3793 101.4 48.9534C100.589 48.5199 99.8931 48.0141 99.319 47.4127C98.7465 46.8139 98.3034 46.0965 97.9839 45.2606C97.6644 44.4394 97.5124 43.4465 97.5124 42.2748C97.5124 40.0067 98.3034 38.208 99.8776 36.8893Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_13_2348)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-308.628 127.788L594.56 127.788L594.56 -1151.73H-308.628L-308.628 127.788Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.1573 71.1655H125.08V24.1523H86.1573V71.1655Z",
    fill: "#58595B"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.086 45.8656C133.511 48.1986 132.906 50.5211 132.259 52.8176C131.615 55.1221 130.929 57.4396 130.221 59.7722H125.23C124.712 58.482 124.148 56.9493 123.545 55.1711C122.936 53.3855 122.316 51.4474 121.664 49.3393C121.019 47.2383 120.36 45.0142 119.685 42.6607C119.007 40.3177 118.35 37.9486 117.721 35.5512H124.478C124.702 36.653 124.957 37.8636 125.232 39.1665C125.506 40.4722 125.794 41.8168 126.096 43.2001C126.397 44.5783 126.719 45.9635 127.049 47.3623C127.381 48.7609 127.722 50.1002 128.066 51.3883C128.44 50.0386 128.806 48.6605 129.164 47.2488C129.517 45.835 129.865 44.4463 130.198 43.0815C130.525 41.7188 130.847 40.3951 131.141 39.1204C131.44 37.8477 131.705 36.653 131.94 35.5512H136.58C136.817 36.653 137.067 37.8477 137.358 39.1204C137.641 40.3951 137.943 41.7188 138.263 43.0815C138.572 44.4463 138.909 45.835 139.247 47.2488C139.594 48.6605 139.95 50.0386 140.319 51.3883C140.666 50.1002 141.012 48.7609 141.36 47.3623C141.708 45.9635 142.035 44.5783 142.334 43.2001C142.633 41.8168 142.921 40.4722 143.2 39.1665C143.475 37.8636 143.725 36.653 143.954 35.5512H150.623C149.989 37.9486 149.337 40.3177 148.66 42.6607C147.977 45.0142 147.325 47.2383 146.673 49.3393C146.031 51.4474 145.397 53.3855 144.781 55.1711C144.161 56.9493 143.588 58.482 143.079 59.7722H138.088C137.366 57.4396 136.665 55.1221 135.975 52.8176C135.286 50.5211 134.663 48.1986 134.086 45.8656Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_13_2348",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: 35,
    width: 34,
    height: 25
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M143.954 35.5512H150.623C149.989 37.9486 149.337 40.3177 148.659 42.6603C147.977 45.0142 147.325 47.2387 146.673 49.3393C146.031 51.4474 145.398 53.3855 144.781 55.1711C144.161 56.9493 143.589 58.4815 143.078 59.7722H138.087C137.366 57.4396 136.665 55.1217 135.975 52.8172C135.287 50.5211 134.663 48.1986 134.086 45.8656C133.511 48.1986 132.906 50.5211 132.259 52.8172C131.615 55.1217 130.929 57.4396 130.221 59.7722H125.23C124.712 58.4815 124.148 56.9493 123.545 55.1711C122.937 53.3855 122.316 51.4474 121.664 49.3393C121.02 47.2387 120.36 45.0142 119.685 42.6603C119.007 40.3177 118.35 37.9486 117.722 35.5512H124.477C124.702 36.653 124.957 37.8632 125.232 39.1665C125.506 40.4722 125.794 41.8168 126.096 43.1996C126.397 44.5778 126.719 45.9635 127.049 47.3623C127.382 48.7609 127.722 50.1002 128.067 51.3883C128.44 50.0386 128.806 48.6601 129.164 47.2488C129.517 45.835 129.866 44.4463 130.198 43.0815C130.525 41.7184 130.847 40.3947 131.141 39.1204C131.44 37.8477 131.705 36.653 131.939 35.5512H136.58C136.817 36.653 137.067 37.8477 137.358 39.1204C137.641 40.3947 137.943 41.7184 138.263 43.0815C138.572 44.4463 138.909 45.835 139.247 47.2488C139.595 48.6601 139.951 50.0386 140.319 51.3883C140.667 50.1002 141.012 48.7609 141.36 47.3623C141.708 45.9635 142.035 44.5778 142.334 43.1996C142.633 41.8168 142.921 40.4722 143.199 39.1665C143.475 37.8632 143.725 36.653 143.954 35.5512Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_13_2348)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-308.628 127.788L594.561 127.788L594.561 -1151.73H-308.628L-308.628 127.788Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.969 70.5249H161.375V24.7992H106.969V70.5249Z",
    fill: "#58595B"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.154 59.7629H161.555V35.547H155.154V59.7629Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_13_2348",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 155,
    y: 35,
    width: 7,
    height: 25
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M155.154 59.7632V35.5473H161.555V59.7632H155.154Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_13_2348)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-308.628 127.788L594.561 127.788L594.561 -1151.73H-308.628L-308.628 127.788Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.402 70.5154H172.307V24.7947H144.402V70.5154Z",
    fill: "#58595B"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.646 29.5078L173.052 28.2925V35.5591H179.391V41.2569H173.052V49.7781C173.052 51.2203 173.289 52.382 173.76 53.2309C174.232 54.0902 175.188 54.5211 176.618 54.5211C177.311 54.5211 178.022 54.4591 178.749 54.3172C179.483 54.1777 180.148 53.9792 180.753 53.7393L181.653 59.0811C180.877 59.4212 180.014 59.7105 179.074 59.958C178.122 60.2005 176.971 60.3245 175.59 60.3245C173.838 60.3245 172.392 60.072 171.246 59.5606C170.097 59.0627 169.179 58.3583 168.494 57.4446C167.808 56.5467 167.329 55.4395 167.054 54.1572C166.775 52.8644 166.646 51.4348 166.646 49.8731V29.5078Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_13_2348",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 166,
    y: 28,
    width: 16,
    height: 33
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M166.646 29.508L173.052 28.2927V35.5593H179.391V41.2571H173.052V49.7783C173.052 51.2206 173.289 52.3818 173.761 53.2311C174.232 54.0904 175.188 54.521 176.618 54.521C177.311 54.521 178.022 54.4594 178.749 54.3174C179.483 54.1775 180.148 53.9795 180.753 53.7395L181.653 59.081C180.877 59.4214 180.014 59.7108 179.074 59.9583C178.123 60.2008 176.971 60.3247 175.59 60.3247C173.838 60.3247 172.392 60.0722 171.246 59.5609C170.096 59.0625 169.179 58.3586 168.494 57.4452C167.809 56.547 167.33 55.4402 167.054 54.1575C166.775 52.8647 166.646 51.4346 166.646 49.8738V29.508Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_13_2348)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-308.628 127.788L594.561 127.788L594.561 -1151.73H-308.628L-308.628 127.788Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.894 71.0771H192.405V17.5402H155.894V71.0771Z",
    fill: "#58595B"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.917 47.6676C183.917 45.915 184.183 44.2638 184.713 42.7156C185.244 41.162 186.009 39.8152 187.012 38.6614C188.017 37.5081 189.233 36.5994 190.67 35.921C192.1 35.2526 193.734 34.9067 195.569 34.9067C196.772 34.9067 197.877 35.0282 198.882 35.2551C199.888 35.4901 200.867 35.818 201.807 36.2434L200.478 41.7222C199.872 41.4794 199.215 41.2679 198.493 41.0769C197.777 40.896 196.97 40.801 196.084 40.801C194.193 40.801 192.778 41.4329 191.853 42.6922C190.912 43.9543 190.454 45.6085 190.454 47.6676C190.454 49.8427 190.889 51.5329 191.771 52.7306C192.636 53.9253 194.167 54.5267 196.344 54.5267C197.12 54.5267 197.947 54.4463 198.841 54.2943C199.728 54.1393 200.544 53.8969 201.297 53.5564L202.194 59.1767C201.446 59.5147 200.519 59.7986 199.401 60.0486C198.277 60.2919 197.047 60.418 195.703 60.418C193.639 60.418 191.856 60.0825 190.369 59.4242C188.88 58.7664 187.651 57.8681 186.692 56.7328C185.726 55.595 185.03 54.2532 184.585 52.7046C184.139 51.1539 183.917 49.4717 183.917 47.6676Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_13_2348",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 34,
    width: 20,
    height: 27
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M190.67 35.9212C192.1 35.2529 193.734 34.907 195.569 34.907C196.772 34.907 197.877 35.028 198.882 35.255C199.887 35.4903 200.867 35.8178 201.807 36.2437L200.478 41.7221C199.872 41.4796 199.215 41.2681 198.493 41.0772C197.776 40.8959 196.97 40.8008 196.084 40.8008C194.193 40.8008 192.778 41.4331 191.853 42.6924C190.912 43.9542 190.454 45.6083 190.454 47.6678C190.454 49.8429 190.89 51.5331 191.771 52.7308C192.636 53.9256 194.167 54.5269 196.344 54.5269C197.12 54.5269 197.947 54.4465 198.841 54.2945C199.728 54.1396 200.544 53.8971 201.296 53.5562L202.193 59.177C201.446 59.5149 200.519 59.7984 199.4 60.0489C198.277 60.2918 197.048 60.4182 195.703 60.4182C193.638 60.4182 191.856 60.0824 190.369 59.424C188.88 58.7662 187.651 57.8683 186.692 56.7334C185.726 55.5952 185.03 54.2535 184.585 52.7048C184.139 51.1541 183.917 49.4715 183.917 47.6678C183.917 45.9153 184.183 44.264 184.713 42.7158C185.244 41.1622 186.009 39.815 187.011 38.6613C188.017 37.508 189.233 36.5996 190.67 35.9212Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_13_2348)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-308.628 127.788L594.561 127.788L594.561 -1151.73H-308.628L-308.628 127.788Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.165 71.1707H212.945V24.1545H173.165V71.1707Z",
    fill: "#58595B"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.335 59.7639V29.4991L212.743 28.2943V35.6488C213.17 35.4964 213.719 35.3494 214.4 35.2103C215.069 35.0734 215.727 35.001 216.356 35.001C218.187 35.001 219.71 35.2719 220.931 35.8063C222.148 36.3432 223.129 37.1045 223.856 38.0874C224.593 39.0656 225.103 40.2369 225.41 41.5816C225.706 42.9359 225.855 44.4435 225.855 46.1002V59.7639H219.449V46.9231C219.449 44.714 219.184 43.1503 218.656 42.224C218.125 41.3127 217.141 40.8512 215.711 40.8512C215.129 40.8512 214.598 40.9057 214.093 41.0087C213.593 41.1172 213.142 41.2357 212.743 41.3571V59.7639H206.335Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_13_2348",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 206,
    y: 28,
    width: 20,
    height: 32
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M206.335 29.4987L212.742 28.2938V35.6488C213.17 35.4959 213.719 35.3489 214.4 35.2099C215.069 35.0729 215.727 35.0009 216.356 35.0009C218.187 35.0009 219.71 35.2719 220.931 35.8058C222.148 36.3431 223.13 37.104 223.856 38.0873C224.592 39.0651 225.103 40.2364 225.41 41.5815C225.706 42.9358 225.855 44.443 225.855 46.1001V59.7634H219.45V46.9226C219.45 44.7139 219.184 43.1498 218.656 42.2235C218.125 41.3127 217.141 40.8508 215.711 40.8508C215.129 40.8508 214.598 40.9052 214.093 41.0086C213.593 41.1167 213.142 41.2352 212.742 41.3566V59.7634H206.335V29.4987Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_13_2348)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-308.628 127.788L594.561 127.788L594.561 -1151.73H-308.628L-308.628 127.788Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.583 70.5161H236.607V17.5414H195.583V70.5161Z",
    fill: "#58595B"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1375 59.7715L13.1375 37.8265C13.1375 37.8265 16.3582 35.073 23.4028 35.073C29.8134 35.073 33.3336 38.5028 33.3336 46.0507V59.7715H26.9306V46.0507C26.9306 41.2433 24.6835 40.9103 22.7638 40.9103C20.8442 40.9103 19.5585 41.9321 19.5585 41.9321V59.7715H13.1375Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_13_2348",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 35,
    width: 21,
    height: 25
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1375 37.8265C13.1375 37.8265 16.3582 35.073 23.4028 35.073C29.8134 35.073 33.3332 38.5024 33.3332 46.0512V59.7715H26.9306V46.0512C26.9306 41.2428 24.6835 40.9103 22.7638 40.9103C20.8442 40.9103 19.5585 41.9325 19.5585 41.9325V59.7715H13.1375L13.1375 37.8265Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_13_2348)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-308.628 127.788L594.561 127.788L594.561 -1151.73H-308.628L-308.628 127.788Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.38562 70.5242H44.0855V24.3212H2.38562L2.38562 70.5242Z",
    fill: "#58595B"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.07349 59.7717L1.07349 29.5017L7.48411 28.2938L7.48411 59.7717H1.07349Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_13_2348",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 28,
    width: 7,
    height: 32
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1.07349 29.5021L7.48411 28.2938L7.48411 59.7717H1.07349L1.07349 29.5021Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_13_2348)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-308.628 127.788L594.561 127.788L594.561 -1151.73H-308.628L-308.628 127.788Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-9.67883 70.5242H18.2366L18.2366 17.5419H-9.67883L-9.67883 70.5242Z",
    fill: "#58595B"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.7716 49.4015H62.3524C62.3524 49.4015 62.6744 54.5444 69.0774 54.5444C72.2832 54.5444 75.4885 53.5197 75.4885 53.5197L76.13 59.0136C76.13 59.0136 72.9272 60.3738 68.4438 60.3738C62.0303 60.3738 56.2638 56.9491 56.2638 47.3474C56.2638 39.7965 60.7472 35.002 67.1557 35.002C76.7716 35.002 77.4156 45.2774 76.7716 49.4015ZM66.8412 39.7965C62.6744 39.7965 62.3524 44.5961 62.3524 44.5961H71.3192C71.3192 44.5961 71.0051 39.7965 66.8412 39.7965Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_13_2348",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 35,
    width: 21,
    height: 26
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M56.264 47.3475C56.264 39.7966 60.7475 35.002 67.1555 35.002C76.7714 35.002 77.4155 45.2779 76.7714 49.4015H62.3526C62.3526 49.4015 62.6746 54.5445 69.0772 54.5445C72.283 54.5445 75.4883 53.5198 75.4883 53.5198L76.1298 59.0137C76.1298 59.0137 72.9271 60.3743 68.4437 60.3743C62.0306 60.3743 56.264 56.9495 56.264 47.3475ZM66.841 39.7966C62.6746 39.7966 62.3526 44.5966 62.3526 44.5966H71.3194C71.3194 44.5966 71.0049 39.7966 66.841 39.7966Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_13_2348)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-308.628 127.788L594.561 127.788L594.561 -1151.73H-308.628L-308.628 127.788Z",
    fill: "#58595B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_13_2348",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 234,
    y: 23,
    width: 43,
    height: 55
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M234.346 28.3C234.346 26.8368 252.777 23.6792 265.137 23.6792C270.497 23.6792 274.716 24.2731 275.795 25.856C281.36 33.2055 242.18 79.3145 238.915 77.9159C236.297 77.2165 259.804 47.868 255.886 35.9849C253.93 29.7012 234.346 30.4001 234.346 28.3Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_13_2348)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.595 88.6995H287.088V12.927H223.595V88.6995Z",
    fill: "#ADADAD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_13_2348",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 267,
    y: 1,
    width: 18,
    height: 19
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M267.635 10.1338C267.635 5.11483 271.436 1.05315 276.12 1.05315C280.809 1.05315 284.605 5.11483 284.605 10.1338C284.605 15.1554 280.809 19.217 276.12 19.217C271.436 19.217 267.635 15.1554 267.635 10.1338Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_13_2348)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.884 29.9697L295.358 29.9697V-9.6994H256.884V29.9697Z",
    fill: "#ADADAD"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterswitch);
export default __webpack_public_path__ + "static/media/Interswitch.8031e0d5c1eeb9a2f924119484951579.svg";
export { ForwardRef as ReactComponent };